<div class="infos_property_container">
  <div>
    <span>Type : </span>
    <span class="infos_property_value fw-bold ms-3">
      {{ propertyType.label }}
    </span>
  </div>
  <div>
    <span *ngIf="propertyType.code !== 'TER'">Année de construction : </span>
    <span *ngIf="propertyType.code !== 'TER'" class="infos_property_value fw-bold ms-3">
      {{ characteristics.constructionYear || "-" }}
    </span>
  </div>
</div>

<div class="characteristics_container">
  <app-caracteristique
    *ngFor="let item of characteristicsList"
    [characteristicItem]="item"
  ></app-caracteristique>
</div>
